import {salesAPI} from "../api/api";
import ShowNotification from "../components/common/Notification/ShowNotification";

const SET_SALES_DATA = 'SET_SALES_DATA';
const SET_SALES_FILTERS = 'SET_SALES_FILTERS';

export const setBlogData = (payload) => {
    return {
        type: SET_SALES_DATA,
        payload: payload
    }
}

export const setSalesFilters = (payload) => {
    return {
        type: SET_SALES_FILTERS,
        payload: payload
    }
}

export const defaultSalesFilters = {
    q: '',
    paymentStatus: '',
    productType: '',
    productId: '',
    dateFrom: '',
    dateTo: '',
    paidFrom: '',
    paidTo: '',
    sortBy: 'id',
    sortDir: 'desc',
    page: 0,
    size: 10,
};

let initialState = {
    products:[
        // {
            // "id": 1,
            // "title": "title 3",
            // "content": "content 3",
            // "imgUrl": "100",
            // "youtubeLink": "1010",
            // "status": 1,
            // // "startDate": "2021-06-28 14:00:00",
            // // "endDate": "2021-08-28 18:00:00",
            // "created_at": "2021-07-21T15:48:51.000000Z",
            // "updated_at": "2021-07-21T15:48:51.000000Z"
        // }
    ],
    totalPages:4,
    totalElements:31,
    size:10,
    filters: { ...defaultSalesFilters },
}

let salesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SALES_DATA:
            return {
                ...state,
                products:action.payload.products,
                totalPages: action.payload.totalPages,
                totalElements: action.payload.totalElements,
                size: action.payload.size,
            }

        case SET_SALES_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload },
            }

        default :
            return state;
    }
}


export const getSalesTh = (page, size, filters = {}) => {
    return async (dispatch) => {
        const params = {
            ...filters,
            page: page ?? filters.page ?? 0,
            size: size ?? filters.size ?? 10,
        };
        let response = await salesAPI.getSales(params);
        if (response) {
            dispatch(setBlogData(response));
        } else {
            let errorMessage = 'Server: ' + (response?.response?.data || 'Unknown error');
            ShowNotification("Error", errorMessage, "danger", 3000)
        }
    }
}

export const applySalesFiltersTh = (filters) => {
    return async (dispatch, getState) => {
        const merged = { ...getState().salesPage.filters, ...filters, page: 0 };
        dispatch(setSalesFilters(merged));
        dispatch(getSalesTh(0, merged.size, merged));
    }
}

export const resetSalesFiltersTh = () => {
    return async (dispatch) => {
        dispatch(setSalesFilters({ ...defaultSalesFilters }));
        dispatch(getSalesTh(0, defaultSalesFilters.size, defaultSalesFilters));
    }
}

export const checkStatusTh = (orderId) => {
    return async (dispatch) => {
        let response = await salesAPI.checkStatus(orderId);
        if (response && response.status === 200) {
            ShowNotification("Succes","Status updated successful", "success", 3000)
            dispatch(getSalesTh(0,10));
        } else {
            let errorMessage='Server: '+(response && response.data ? response.data.message : 'Unknown error');
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}

export const refreshStatusTh = (saleId) => {
    return async (dispatch, getState) => {
        const data = await salesAPI.refreshStatus(saleId);
        if (!data) return;
        const { old_paymentStatus, new_paymentStatus, bank_status } = data;
        if (old_paymentStatus === new_paymentStatus) {
            ShowNotification("Məlumat", `Status dəyişmədi: ${bank_status || ''}`, "info", 3000);
        } else if (new_paymentStatus === 1) {
            ShowNotification("Uğurlu", "✅ Ödəniş təsdiqləndi", "success", 3000);
        } else if (new_paymentStatus === 2) {
            ShowNotification("Uğursuz", "❌ Ödəniş uğursuz", "danger", 3000);
        } else {
            ShowNotification("Məlumat", `Yeni status: ${new_paymentStatus}`, "info", 3000);
        }
        const filters = getState().salesPage.filters;
        dispatch(getSalesTh(filters.page || 0, filters.size || 10, filters));
    }
}

export const refreshPendingTh = (days = 7) => {
    return async (dispatch, getState) => {
        const data = await salesAPI.refreshPending(days);
        if (!data) return;
        ShowNotification(
            "Toplu yoxlama",
            `${data.updated_to_paid} təsdiqləndi, ${data.updated_to_failed} uğursuz, ${data.unchanged} dəyişməz`,
            "info",
            5000
        );
        const filters = getState().salesPage.filters;
        dispatch(getSalesTh(filters.page || 0, filters.size || 10, filters));
    }
}

export const getSaleHistoryTh = (saleId) => {
    return async () => {
        return await salesAPI.getSaleHistory(saleId);
    }
}
/*
export const addBlogTh = (product) => {
    return async (dispatch) => {
        let response = await blogsAPI.addBlog(product);
        debugger
        if (response.status===201) {
            debugger
            ShowNotification("Succes","Blog added successful", "success")
            dispatch(getSalesTh(0,10));
        } else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const updateBlogTh = (product) => {
    return async (dispatch) => {
        debugger
        let response = await blogsAPI.editBlog(product);
        if (response.status === 200) {
            ShowNotification("Succes","Blog updated successful", "warning")
            dispatch(getSalesTh(0,10));
        } else {
            let errorMessage='Server: '+response.data.message;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const deleteBlogTh = (productId) => {
    return async (dispatch) => {
        debugger
        let response = await blogsAPI.deleteBlog(productId );
        if (response.status === 200) {
            // dispatch(deleteBuildingData(response.content));
            ShowNotification("Succes","Blog deleted successful", "danger")

            dispatch(getSalesTh(0,10));
        }else {
            let errorMessage='Server: '+response.data.message ;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
 */
export default salesReducer;
